import React  from 'react';
import ForgotPasswordComp from '../components/Login/forgotPasswordComp';
function ForgotPassword() {
  return (
    <>
    <ForgotPasswordComp />
    </>
  );
}

export default ForgotPassword;
